import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const ProjectSidebar = ({ project, onClose, isOpen }) => {
    const sidebarRef = useRef(null);
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
          onClose();
        }
      };
  
      if (isOpen) {
        document.addEventListener('mousedown', handleClickOutside);
      }
  
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isOpen, onClose]);
  
    return (
      <>
        {isOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40 transition-opacity duration-300 ease-in-out" />
        )}
        <div 
          ref={sidebarRef}
          className={`fixed top-0 right-0 h-full bg-stone-100 dark:bg-[#111318] shadow-lg w-full sm:w-2/3 md:w-1/2 lg:w-1/3 p-6 z-50 transform transition-transform duration-300 ease-in-out ${
            isOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <button onClick={onClose} className="mb-4 px-4 py-2 dark:text-white text-[#111318] rounded">
            <FontAwesomeIcon icon={faArrowLeft} className='text-sm pr-3' /> Back
          </button>
          <hr className='h-2' />
          {project && (
            <>
              <h2 className="text-lg text-gray-900 dark:text-[rgb(211,219,236)] py-4 font-medium">{project.title}</h2>
              <img src={project.media} alt={project.title} className="mb-4 w-full h-auto" />
              <p className='mb-4 text-gray-900 dark:text-[rgb(211,219,236)] font-medium text-lg'>Overview : </p>
              <p className="mb-4 text-gray-900 dark:text-[rgb(211,219,236)]">{project.description}</p>
              <p className='mb-4 text-gray-900 dark:text-[rgb(211,219,236)] font-medium text-lg'>Technologies : </p>
              <div className="mb-4">
                {project.technologies.map((tech, index) => (
                  <span key={index} className="inline-block bg-gray-200 px-3 py-1 rounded-full mr-2 mb-2">
                    {tech}
                  </span>
                ))}
              </div>
              <p class="dark:text-white flex items-center mt-2 lg:mt-0">
                <span class="mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-external-link"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                </span> Preview :&nbsp; 
                <span class="font-medium transition-all duration-300 ease-in-out hover:text-accent1 underline">
                <a href={project.link} target="_blank" rel="noopener noreferrer">{project.link.includes('github') ? 'Github' : 'Web'} </a>
                </span>
            </p>
              
            </>
          )}
        </div>
      </>
    );
  };

export default ProjectSidebar;